/**
 * Helper class to make the handling fetch and error more concise.
 * Todo, i need to decide if this naming is nice
 */
export class Fetchable {
	fetching = $state(false);
	error = $state<any>();
	/* Goes true when a successul fetch happened. Is reset on the next fetch */
	success = $state(false);
	fetch<R>(fn: () => Promise<R>): Promise<R> {
		return wrapAsyncCall(
			fn,
			(f) => (this.fetching = f),
			(e) => (this.error = this.processError(e)),
			(s) => (this.success = s)
		);
	}

	private processError = (e: any) => e;

	constructor(options?: { processError?: (e: any) => any; initiallyFetching?: boolean }) {
		this.processError = options?.processError || this.processError;
		this.fetching = options?.initiallyFetching || this.fetching;
	}
}

/**
 * Wraps an async call and allows to set fetching and error as we need this very often
 * @param fn function to handle
 * @param onFetching called if fetching state changes
 * @param onError called if error was handled
 */
export async function wrapAsyncCall<R>(
	fn: () => Promise<R>,
	onFetching: (f: boolean) => {},
	onError: (e: any) => {},
	onSuccess: (s: boolean) => {}
): Promise<R> {
	onFetching(true);
	onError(null);
	onSuccess(false);
	try {
		const result = await fn();
		onSuccess(true);
		return result;
	} catch (e) {
		if (e instanceof Error) {
			(e as any).__sentryHandled = true;
		}
		onError(e);
	} finally {
		onFetching(false);
	}
}
